import { render } from "./FacturaModal.vue?vue&type=template&id=0982ab4b"
import script from "./FacturaModal.vue?vue&type=script&lang=js"
export * from "./FacturaModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__